import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';
import { withRouter } from 'react-router-dom';
import { length } from 'redux-form-validators';

import {
    FIRSTNAME_LENGTH,
    NAME_LENGTH,
    CITY_LENGTH,
    ADDRESS_LENGTH,
    POSTCODE_LENGTH
} from '../../../constants/form';
import { MADAME, MONSIEUR } from '../../../constants/civilities';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import {
    EmailInputFieldComponent,
    FormComponent,
    NumberInputFieldComponent,
    SelectFieldComponent,
    TextInputFieldComponent
} from '../../form';
import LocalizedNavLink from '../../router/LocalizedNavLink';

const mapCountries = countries => {
    return [
        { label: countries.FRANCE, value: countries.FRANCE },
        { label: countries.BELGIQUE, value: countries.BELGIQUE }
    ];
};

const AddressForm = ({
    formName,
    cappingError,
    isFetching,
    handleSubmit,
    merchantCardPath,
    i18n,
    i18nCommon,
    COUNTRIES,
    CIVILITIES,
    initialValues
}) => {
    return (
        <FormComponent
            form={formName}
            initialValues={initialValues}
            classNameInputContainer="grid-2 has-gutter"
            requestSubmit={isFetching}
            onSubmit={() => handleSubmit()}
            submitText={i18nCommon.VALIDATE_USER_DETAILS}
            paymentLockLabel={i18nCommon.PAYMENT_LOCKPAD_LABEL}>
            <EmailInputFieldComponent
                name="email"
                i18nFeatureForm={i18nCommon}
                label={i18nCommon.EMAIL}
                placeholder={i18nCommon.PLACEHOLDER_EMAIL}
                classNameInputContainer="full"
                readOnly
            />
            <SelectFieldComponent
                name="civility"
                i18nFeatureForm={i18nCommon}
                label={i18nCommon.LABEL_CIVILITY}
                isRequired
                hideRequired
                isDisabled
                defaultOptionLabel="--"
                classNameInputContainer="full"
                options={[
                    { label: CIVILITIES.MONSIEUR, value: MONSIEUR },
                    { label: CIVILITIES.MADAME, value: MADAME }
                ]}
            />
            <TextInputFieldComponent
                name="lastname"
                i18nFeatureForm={i18nCommon}
                placeholder={i18nCommon.LABEL_LASTNAME}
                label={i18nCommon.LABEL_LASTNAME}
                isRequired
                hideRequired
                readOnly
                validate={[
                    length({
                        max: NAME_LENGTH,
                        msg: format(
                            i18nCommon.TEXT_TOOLONG,
                            NAME_LENGTH,
                            NAME_LENGTH > 1 ? 's' : ''
                        )
                    })
                ]}
            />
            <TextInputFieldComponent
                name="firstname"
                i18nFeatureForm={i18nCommon}
                placeholder={i18nCommon.LABEL_FIRSTNAME}
                label={i18nCommon.LABEL_FIRSTNAME}
                isRequired
                hideRequired
                readOnly
                validate={[
                    length({
                        max: FIRSTNAME_LENGTH,
                        msg: format(
                            i18nCommon.TEXT_TOOLONG,
                            FIRSTNAME_LENGTH,
                            FIRSTNAME_LENGTH > 1 ? 's' : ''
                        )
                    })
                ]}
            />
            <TextInputFieldComponent
                name="address"
                i18nFeatureForm={i18nCommon}
                classNameInputContainer="full"
                placeholder={i18nCommon.LABEL_ADDRESS}
                label={i18nCommon.LABEL_ADDRESS}
                isRequired
                hideRequired
                readOnly
                validate={[
                    length({
                        max: ADDRESS_LENGTH,
                        msg: i18nCommon.ADDRESS_SIZE_ERROR
                    })
                ]}
            />
            <NumberInputFieldComponent
                name="zipcode"
                i18nFeatureForm={i18nCommon}
                placeholder={i18nCommon.LABEL_ZIPCODE}
                label={i18nCommon.LABEL_ZIPCODE}
                isRequired
                hideRequired
                readOnly
                validate={[
                    length({
                        max: POSTCODE_LENGTH,
                        msg: i18nCommon.ZIP_CODE_SIZE_ERROR
                    })
                ]}
            />
            <TextInputFieldComponent
                name="city"
                i18nFeatureForm={i18nCommon}
                placeholder={i18nCommon.LABEL_CITY}
                label={i18nCommon.LABEL_CITY}
                isRequired
                hideRequired
                readOnly
                validate={[length({ max: CITY_LENGTH, msg: i18nCommon.CITY_SIZE_ERROR })]}
            />
            <SelectFieldComponent
                name="country"
                i18nFeatureForm={i18nCommon}
                label={i18nCommon.LABEL_COUNTRY}
                isRequired
                hideRequired
                isDisabled
                defaultOptionLabel={i18nCommon.LABEL_COUNTRY}
                defaultValue="FRANCE"
                classNameInputContainer="full"
                options={COUNTRIES}
            />

            <React.Fragment>
                {cappingError && (
                    <p className="error-message">
                        {convertHtmlToReactDomWithParams(i18n.CAPPING_ERROR_MESSAGE_1)}
                        <LocalizedNavLink
                            to={`${merchantCardPath}#conditions`}
                            title={i18n.CAPPING_ERROR_MESSAGE_2}>
                            {i18n.CAPPING_ERROR_MESSAGE_2}
                        </LocalizedNavLink>
                        {i18n.CAPPING_ERROR_MESSAGE_3}
                    </p>
                )}
            </React.Fragment>
        </FormComponent>
    );
};

AddressForm.propTypes = {
    formName: PropTypes.string,
    cappingError: PropTypes.bool,
    isFetching: PropTypes.bool,
    handleSubmit: PropTypes.func,
    merchantCardPath: PropTypes.string
};

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        i18n: state.i18n.page.EBON,
        i18nCommon: state.i18n.feature.form,
        COUNTRIES: mapCountries(state.i18n.feature.form.COUNTRIES),
        CIVILITIES: state.i18n.feature.form.CIVILITIES,
        initialValues: {
            email: user.email ? user.email : '',
            civility: user.civility ? user.civility : '',
            lastname: user.lastname ? user.lastname : '',
            firstname: user.firstname ? user.firstname : '',
            address: user.address ? user.address : '',
            zipcode: user.postcode ? user.postcode : '',
            city: user.city ? user.city : '',
            country: user.country ? user.country : ''
        }
    };
};

export default withRouter(connect(mapStateToProps)(AddressForm));



// WEBPACK FOOTER //
// ./src/components/funnel/address-step/AddressForm.js